import React from "react";
import { TipStepInterface } from "../../../../store/mine_craft/tipStepsSlice";

import { Button, Form, Input } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import { AVAILABLE_LOCALES } from "../../../../configs/constants";

interface propsInterface {
  params: TipStepInterface;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const locales: string[] = [...Object.keys(params.title_translations), ...params.empty_locales];

  const renderTitle = (locale: string) => (
    <Form.Item key={locale} name={['title_translations', locale]} label={`${AVAILABLE_LOCALES[locale]} :${locale}`}>
      <Input.TextArea rows={2} placeholder={`Title_${locale}`} />
    </Form.Item>
  )

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='tip_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <div className='v-group-dropzone'>
        <FileDropzone name='image' label='Image' preview={params?.image_url} />
      </div>

      { locales.map(renderTitle) }

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
